import React, { Component } from "react";
import { Link } from "react-router-dom";

class Info extends Component {
  state = { contactClientCare: null };
  componentDidMount() {
    var search = this.props.location.search.substring(1);

    var contactClientCare = JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );

    this.setState({ contactClientCare });
  }
  render() {
    const { _ } = this.props;
    const fields = _.ClientForms.ContactClientCare.Fields;
    const { contactClientCare } = this.state;
    return (
      <div className="contact-client-care">
        <h2 className="ml-3"> {_.ClientForms.ContactClientCare.Title}</h2>
        <div className="ml-3 mb-5  d-flex report-sent-message">
          <i className="icon-omni-checkbox-true mr-2"></i>
          <h6>{_.ClientForms.ContactClientCare.InfoMessage}</h6>
        </div>
        {contactClientCare && (
          <div>
            <div className="d-flex flex-wrap ml-3 contact-client-care-info">
              <div className="d-flex flex-wrap row report-details-1">
                {Object.keys(fields).map((field) => {
                  const val = decodeURIComponent(contactClientCare[field]);
                  return (
                    <div className="col-4">
                      <h6>{fields[field]}</h6>
                      <p>{val ? val : "-"}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="d-flex mt-3 ml-3 green-button justify-content-start ">
              <Link to="/client-forms">
                <button
                  className="d-flex justify-content-center styled-button "
                  type="button"
                >
                  {_.ClientForms.ReturnToClientForms}
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Info;
